import { ComponentFactoryResolver, Directive, Input, ViewContainerRef } from '@angular/core';
import { CheckIconComponent, CrossIconComponent } from '../components';

@Directive({
  selector: '[showCheckOrCrossIcon]',
})
export class ShowCheckOrCrossIconDirective {
  @Input() set showCheckOrCrossIcon(isVisible: boolean) {
    this.viewContainer.clear();

    if (isVisible) {
      const checkIconFactory = this.resolver.resolveComponentFactory(CheckIconComponent);
      this.viewContainer.createComponent(checkIconFactory);
    } else {
      const crossIconFactory = this.resolver.resolveComponentFactory(CrossIconComponent);
      this.viewContainer.createComponent(crossIconFactory);
    }
  }

  constructor(private viewContainer: ViewContainerRef, private resolver: ComponentFactoryResolver) {}
}
